module.exports = __webpack_public_path__ + "static/media/S37_black.77542dac.png";